var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isAllowedEmailDomain, isEmail, isRequiredText } from '../../utils';
import { validateTrialStatus } from '../proffit_search/proffit_search_common_validate';
/**
 * 招待されるメールアドレスが登録済みかどうか非同期でバリデーションを実行する
 * @param formValues
 * @param dispatch
 * @param formProps
 * @param fieldName
 * @returns {Promise<void>}
 */
const asyncEmailValidate = (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
    const { syncErrors, unmountRef } = formProps;
    const promiseList = (formValues.email || [])
        .filter((unused, i) => !(syncErrors.email || [])[i])
        .map((email) => validateTrialStatus(dispatch, email, fieldName));
    const result = yield Promise.all(promiseList);
    if (unmountRef.current) {
        return;
    }
    const errorObj = { email: [] };
    result
        .filter((v) => v.error)
        .forEach((v) => {
        const index = formValues.email.findIndex((email) => email === v.email);
        errorObj.email[index] = v.error;
    });
    if (Object.keys(errorObj).length > 0) {
        throw errorObj;
    }
});
export const slideSearchTrialValidate = {
    email: [
        (value, record) => {
            const { email = [] } = record;
            const isAllEmpty = email.every((v) => !v);
            return isAllEmpty
                ? isRequiredText('メールアドレスを入力してください')(value)
                : '';
        },
        (value) => value ? isEmail('メールアドレス形式が正しくありません')(value) : '',
        (value) => value
            ? isAllowedEmailDomain('フリーメールアドレスは使用できません')(value)
            : '',
        (value, record) => {
            const { email = [] } = record;
            return email.filter((v) => v && v === value).length > 1
                ? '他と重複したメールアドレスが入力されています'
                : '';
        },
        (value, record, props) => {
            const { profile = {} } = props;
            const { email: selfEmail } = profile;
            return selfEmail === value ? '自身のメールアドレスは入力できません' : '';
        },
    ],
    form: (formValues, dispatch, formProps, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        if (fieldName && fieldName.match(/email\[\d+]/)) {
            yield asyncEmailValidate(formValues, dispatch, formProps, fieldName);
        }
    }),
};
export default slideSearchTrialValidate;
